<!-- =========================================================================================
  File Name: SigepTabServices.vue
  Description: Sigep Services Tab content
========================================================================================== -->

<template>
<vs-alert active="true" class="mb-10" v-if="data_local.hasOwnProperty('services') && data_local.services instanceof Array">
    Favor preencher as suas credenciais na aba <code>Informações</code> para exibição de serviços habilitados no seu cartão de postagem do SIGEP
</vs-alert>

<div id="sigep-tab-services" v-else>

    <vs-alert active="true" class="mb-10">
        Segue abaixo a relação de <code>serviços habilitados</code> do seu Cartão de Postagem
    </vs-alert>

    <div class="vx-row"> 


        <div class="vx-col w-full">

            <!-- Col Header -->
            <!--  <div class="flex items-end">
                <feather-icon icon="InfoIcon" class="mr-2" svgClasses="w-5 h-5" />
                <span class="leading-none font-medium">Services</span>
            </div> -->

            <div>

                <vs-table hoverFlat :data="data_local.services">
                    <vs-th><strong>Código</strong></vs-th>
                    <vs-td><strong>Nome do Serviço</strong></vs-td>
                    <vs-tr v-for="(item, key, index) in data_local.services" :key="index">
                        <vs-th>{{ key }}</vs-th>
                        <vs-td>{{ typeof item === 'string' || item instanceof String ? item : item.descricao }}</vs-td>
                    </vs-tr>
                </vs-table>

            </div>
        </div>

    </div>

    <!-- Save & Reset Button -->

</div>
</template>

<script>
//import flatPickr from 'vue-flatpickr-component'
//import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'

export default {
    components: {
        vSelect,
        // flatPickr
    },
    props: {
        data: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {

            data_local: this.$store.state.sigep.info,

        }
    },
    computed: {

    },
    methods: {

    },
}
</script>

<style lang="scss">
#sigep-tab-services {
    .vs-con-tbody {
        border: 0px;
    }

}
</style>
